import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-pointer",
  "use": "arrow-pointer-usage",
  "viewBox": "0 0 16.042 98",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.042 98\" id=\"arrow-pointer\">\n    <g id=\"arrow-pointer_Symbol_1_1\" data-name=\"Symbol 1 – 1\" transform=\"translate(-82.18)\">\n        <circle id=\"arrow-pointer_Ellipse_490\" data-name=\"Ellipse 490\" cx=\"8.021\" cy=\"8.021\" r=\"8.021\" transform=\"translate(82.18 81.958)\" />\n        <path id=\"arrow-pointer_Path_5719\" data-name=\"Path 5719\" d=\"M310.5,89.979h8.049L314.524,0Z\" transform=\"translate(-224.323)\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol